import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getDates } from '../util/axiosHelper';
import { fetchCustomerAccountReport, removeAccount } from '../store/actions/accountActions';
import { removeAgent } from '../store/actions/agentActions';
import { buttonText } from '../util/constants';

import './ButtonNavigation.css';

export class ButtonNavigation extends Component {
  static handleAccountHistoryButton({ accountNumber, divisionBillingId, accountType }, fetchAccountReport) {
    const { fromDate, toDate } = getDates();
    fetchAccountReport(accountNumber, divisionBillingId, fromDate, toDate, accountType);
  }

  static handleAccountSearchButton(removeAccountProp, removeAgentProp, displaySearch) {
    // Remove query params without reloading
    window.history.replaceState({}, document.title, window.location.pathname);
    removeAgentProp();
    removeAccountProp();
    displaySearch();
  }

  static handleUsageReportButton(removeAccountProp, removeAgentProp, displayCSR) {
    removeAccountProp();
    removeAgentProp();
    displayCSR();
  }

  render() {
    const {
      account: { accounts },
      agent: { agents },
      chosenAccount,
      didPickAccount,
      handleCSRDisplay,
      handleSearchDisplay,
      fetchCustomerAccountReport,
      removeAccount,
      removeAgent,
      user: { account, agent },
    } = this.props;
    const isEmpty = accnt => Object.entries(accnt).length === 0;

    const usageButton = agent ? (
      <button
        name="usage report"
        type="submit"
        className="nav-buttons"
        onClick={() => ButtonNavigation.handleUsageReportButton(removeAccount, removeAgent, handleCSRDisplay)}
      >
        {buttonText.csrButton}
      </button>
    ) : null;

    const historyButton = account ? (
      <button
        name="account history"
        type="submit"
        className="nav-buttons"
        onClick={() => ButtonNavigation.handleAccountHistoryButton(chosenAccount, fetchCustomerAccountReport)}
        disabled={!didPickAccount}
      >
        {buttonText.accountHistoryButton}
      </button>
    ) : null;

    return (
      <div id="nav-button-container">
        {usageButton}
        <div className="float-right">
          <button
            name="account search"
            type="submit"
            className="nav-buttons mrg-rgt"
            onClick={() =>
              (accounts && !isEmpty(accounts)) || (agents && !isEmpty(agents))
                ? ButtonNavigation.handleAccountSearchButton(removeAccount, removeAgent, handleSearchDisplay)
                : handleSearchDisplay()
            }
          >
            {buttonText.accountSearchButton}
          </button>
          {historyButton}
        </div>
      </div>
    );
  }
}

export function mapStateToProps({
  access: { user },
  agent,
  account,
  targetAccount: { didPickAccount, chosenAccount },
}) {
  return { agent, account, didPickAccount, chosenAccount, user };
}

export default connect(mapStateToProps, {
  fetchCustomerAccountReport,
  removeAccount,
  removeAgent,
})(ButtonNavigation);
